// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1lQ6K","checkboxCol":"Table_checkboxCol__qnyAP","emailCol":"Table_emailCol__bbteG","actionCol":"Table_actionCol__QJmQX"};